import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import TableContainer from '../../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import commonDataSvg from '../../../../assets/images/svg/commonData.svg'
import { numberWithCommas } from "../../../../helpers/globalHelper"

import DeleteModal from '../../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useCommonDataCreateMutation, useCommonDataDeleteMutation, useCommonDataFindAllQuery, useCommonDataUpdateMutation } from '../../../../store';

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [commonDataOne, setCommonDataOne] = useState<any>(null)
  const [commonDataList, setCommonDataList] = useState<any>();
  const [commonDataCount, setCommonDataCount] = useState<any>();

  const { data, error, isFetching } = useCommonDataFindAllQuery(customQuery);

  const [commonDataCreate, commonDataCreateResult] = useCommonDataCreateMutation();
  const [commonDataUpdate, commonDataUpdateResult] = useCommonDataUpdateMutation();
  const [commonDataDelete, commonDataDeleteResult] = useCommonDataDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setCommonDataList(data?.data)
    setLoading(false)
    setCommonDataCount(commonDataList?.length)

    setCustomPagination(data?.pagination)
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    console.log(tempQuery);

    setCustomQuery(tempQuery)
  }, [data, commonDataCount, customPageSize, customPageLength, customPagination])


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCommonDataOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempCommonData = arg;

    setCommonDataOne({
      id: tempCommonData.id,
      group_name: tempCommonData.group_name,
      code: tempCommonData.code,
      name: tempCommonData.name,
      description: tempCommonData.description,
      sort_order: tempCommonData.sort_order,
      attr1_val: tempCommonData.attr1_val,
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setCommonDataOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (commonDataOne) {
      commonDataDelete(commonDataOne.id)
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setCommonDataOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
        }
      },
      {
        header: "Бүлгийн нэршил",
        accessorKey: "group_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Нэр',
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Тайлбар',
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Орчуулга',
        accessorKey: "attr1_val",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const commonDataData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(commonDataData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick]
  );


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: commonDataOne?.id,
      group_name: commonDataOne?.group_name,
      code: commonDataOne?.code,
      name: commonDataOne?.name,
      description: commonDataOne?.description,
      attr1_val: commonDataOne?.attr1_val,
      sort_order: commonDataOne?.sort_order,
    },
    validationSchema: Yup.object({
      group_name: Yup.string().required("Утга оруулна уу !"),
      code: Yup.number().required("Утга оруулна уу !"),
      name: Yup.string().required("Утга оруулна уу !"),
      description: Yup.string().required("Утга оруулна уу !"),
      attr1_val: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateCommonDataList = {
          id: commonDataOne ? values.id : 0,
          parent_id: null,
          group_name: values.group_name,
          code: values.code,
          name: values.name,
          description: values.description,
          sort_order: null,
          css_name: null,
          multi_lang_code: null,
          attr1_val: values.attr1_val,
          attr2_val: null,
          attr3_val: null,
          attr4_val: null,
          attr5_val: null,
          use_yn: true,
          del_yn: true

        };
        commonDataUpdate(updateCommonDataList)
      } else {
        const newCommonDataList = {
          parent_id: null,
          group_name: values["group_name"],
          code: values["code"],
          name: values["name"],
          description: values["description"],
          sort_order: values["sort_order"],
          css_name: null,
          multi_lang_code: null,
          attr1_val: values["attr1_val"],
          attr2_val: null,
          attr3_val: null,
          attr4_val: null,
          attr5_val: null,
        };
        commonDataCreate(newCommonDataList)
        console.log('===create==', newCommonDataList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={commonDataOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={commonDataSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(commonDataCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={commonDataList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Нийтлэг дата засах" : "Нийтлэг дата нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label> Бүлгийн нэршил </Label>
                  <Input
                    name="group_name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.group_name || ""}
                    invalid={
                      validation.touched.group_name && validation.errors.group_name ? true : false
                    }
                  />
                  {validation.touched.group_name && validation.errors.group_name ? (
                    <FormFeedback type="invalid">{validation.errors.group_name}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Код </Label>
                  <Input
                    name="code"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code && validation.errors.code ? true : false
                    }
                  />
                  {validation.touched.code && validation.errors.code ? (
                    <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label> Нэр</Label>
                  <Input
                    name="name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Тайлбар</Label>
                  <Input
                    name="description"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.description || ""}
                    invalid={
                      validation.touched.description && validation.errors.description ? true : false
                    }
                  />
                  {validation.touched.description && validation.errors.description ? (
                    <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Sort</Label>
                  <Input
                    name="sort_order"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.sort_order || ""}
                    invalid={
                      validation.touched.sort_order && validation.errors.sort_order ? true : false
                    }
                  />
                  {validation.touched.sort_order && validation.errors.sort_order ? (
                    <FormFeedback type="invalid">{validation.errors.sort_order}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Орчуулга </Label>
                  <Input
                    name="attr1_val"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.attr1_val || ""}
                    invalid={
                      validation.touched.attr1_val && validation.errors.attr1_val ? true : false
                    }
                  />
                  {validation.touched.attr1_val && validation.errors.attr1_val ? (
                    <FormFeedback type="invalid">{validation.errors.attr1_val}</FormFeedback>
                  ) : null}
                </div>


              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;